import { instance } from "api/apiBase";
import { useMakeDecisionController } from "shared/app/MakeDecisionModal/controller";
import { Button, ButtonSize } from "shared/components";
import { Scales01 } from "untitledui-js-base";
import {
  QueryObserverResult,
  RefetchOptions,
  useMutation
} from "@tanstack/react-query";
import { Application } from "types/application";
import { VerificationStatus } from "shared/types";

export const SkippedReportView = ({
  refetch,
  applicantId,
  applicationId,
  verificationId,
  verificationStatus
}: {
  applicantId: number;
  applicationId: number;
  verificationId: number;
  verificationStatus: VerificationStatus;
  refetch: (
    options?: RefetchOptions
  ) => Promise<QueryObserverResult<Application | undefined, unknown>>;
}) => {
  const { applicationMeta } = useMakeDecisionController(String(applicationId));
  const { mutate, isPending } = useMutation({
    mutationFn: () => {
      return instance.post(
        `/portal/v1/applications/${applicationId}/applicants/${applicantId}/verifications/${verificationId}/run_report`
      );
    },
    onSuccess: () => {
      //refetch for report page
      refetch();
      //refetch for make decision modal
      applicationMeta.refetch();
    }
  });

  if (verificationStatus === VerificationStatus.Pending)
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="flex max-w-md flex-col items-center justify-center gap-6 p-6">
          <div className="rounded-full bg-alpha-40 p-5">
            <Scales01 size="24px" className="stroke-content-400" />
          </div>

          <div className="space-y-2">
            <p className="text-content-500 font-bold text-base text-center">
              This report will be run conditionally
            </p>
            <p className="text-center text-sm font-medium text-content-300">
              This report will be run after all reports are ready, including
              those that need to be run manually, if it is essential to
              determine the recommended decision
            </p>
          </div>
        </div>
      </div>
    );

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex max-w-md flex-col items-center justify-center gap-6 p-6">
        <div className="rounded-full bg-alpha-40 p-5">
          <Scales01 size="24px" className="stroke-content-400" />
        </div>

        <div className="space-y-2">
          <p className="text-content-500 font-bold text-base text-center">
            This report was not run
          </p>
          <p className="text-center text-sm font-medium text-content-300">
            This report was not run because it was not essential to determine
            the recommended decision
          </p>
        </div>

        <Button
          size={ButtonSize.SM}
          onClick={() => mutate()}
          loading={isPending}
        >
          Run anyway
        </Button>
      </div>
    </div>
  );
};
